import { ThingNameSchema } from '@org-avp/device-models';
import { BrandSchema, KvpsDealerIdSchema, MarketSchema } from '@org-avp/models';
import { z } from 'zod';

export const SessionIdSchema = z.string().uuid();
export type SessionId = z.infer<typeof SessionIdSchema>;

export const DeviceStatusSchema = z.enum(['pending', 'pairing-failed', 'online', 'offline']);
export type DeviceStatus = z.infer<typeof DeviceStatusSchema>;

export const DeviceSchema = z.object({
  thingName: ThingNameSchema,
  displayName: z.string(),
  sessionId: SessionIdSchema.optional(),
  /** @deprecated Use `status` field instead */
  online: z.boolean().optional(),
  lastOnlineAt: z.number().optional(),
  idleAppOwner: z.string().optional(),
  /** The URL of the idle app currently configured for this device. */
  idleAppUrl: z.url().optional(),
  serialNumber: z.string().optional(),
  /** When the device has been created. Timestamp in seconds since epoch. */
  createdAt: z.int().optional(),
});
export type Device = z.infer<typeof DeviceSchema>;

export const DeviceManageSchema = z.object({
  thingName: ThingNameSchema,
  displayName: z.string(),
  serialNumber: z.string().optional(),
  status: DeviceStatusSchema,
  lastOnlineAt: z.number().optional(),
  brand: BrandSchema,
  market: MarketSchema,
  dealerId: KvpsDealerIdSchema,
  /** The URL of the idle app currently configured for this device. */
  idleAppUrl: z.string().url().optional(),
});
export type DeviceManage = z.infer<typeof DeviceManageSchema>;

export const IdleConfigUpdateSchema = z.object({
  url: z.string().url(),
  config: z.string(),
});
export type IdleConfigUpdate = z.infer<typeof IdleConfigUpdateSchema>;

export const SessionCreateSchema = z.object({
  url: z.string().url(),
  config: z.string().optional(),
});
export type SessionCreate = z.infer<typeof SessionCreateSchema>;

export const SessionUpdateSchema = z.object({
  config: z.string(),
});
export type SessionUpdate = z.infer<typeof SessionUpdateSchema>;
